import { Component, OnInit, Input } from "@angular/core";
import formatter from "../pipes/format-intergamma-curency";

@Component({
    selector: "ig-currency",
    templateUrl: "./currency.component.html",
    styleUrls: ["./currency.component.scss"],
})
export class CurrencyComponent implements OnInit {
    @Input()
    public value: number | string;

    @Input()
    public sign: boolean;

    @Input()
    public sup: boolean;

    constructor() {}

    public get formatted() {
        let full = formatter(this.value);

        if (this.sign === false) {
            full = this.stripSign(full);
        }

        const [integers, decimals] = full.split(".");

        return {
            full,
            integers,
            decimals,
        };
    }

    ngOnInit() {}

    public stripSign(str: any) {
        if (typeof str === "string") {
            return str.replace(/€/, "").trim();
        }
    }
}
